module.exports = __webpack_public_path__ + "static/media/medicine_crop.97223dc1.jpg";